/*
 * Copyright (c) 2015 - 2023 by KAA Soft. All rights reserved.
 */

export var loadingButton = {
  start: function start(btn) {
    var loadingIcon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor" class="icon loading"><path d="m6.27 16.14-1.44 1.39a1 1 0 0 0 0 1.42 1 1 0 0 0 .72.3 1 1 0 0 0 .67-.25l1.44-1.39a1 1 0 0 0-1.39-1.44Zm11.46 0a1 1 0 0 0-1.39 1.44L17.78 19a1 1 0 0 0 .69.28 1 1 0 0 0 .72-.3 1 1 0 0 0 0-1.42zM12 18a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1Zm5-9.86a1 1 0 0 0 .69-.28l1.44-1.39A1 1 0 0 0 17.78 5l-1.44 1.42a1 1 0 0 0 0 1.41 1 1 0 0 0 .66.31ZM6.22 5a1.012 1.012 0 0 0-1.39 1.47l1.44 1.39a1 1 0 0 0 .73.28 1 1 0 0 0 .72-.31 1 1 0 0 0 0-1.41ZM6 12a1 1 0 0 0-1-1H3a1 1 0 0 0 0 2h2a1 1 0 0 0 1-1zm15-1h-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2zm-9-9a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0V3a1 1 0 0 0-1-1Z"></path></svg>';
    var icon = btn.querySelector('.icon');
    btn.disabled = true;
    if (!!icon) {
      icon.style.display = 'none';
      // original btn icon
      icon.classList.add('obn');
      icon.insertAdjacentHTML('afterend', loadingIcon);
      return;
    }
    btn.classList.add('btn-loading');
  },
  finish: function finish(btn) {
    var icon = btn.querySelector('.icon.obn');
    var loadingIcon = btn.querySelector('.icon.loading');
    btn.disabled = false;
    if (!!icon) {
      icon.style.display = '';
      icon.classList.remove('obn');
      loadingIcon.remove();
      return;
    }
    btn.classList.remove('btn-loading');
  }
};